import { render, staticRenderFns } from "./businessOwner.vue?vue&type=template&id=0d5e0d98&scoped=true"
import script from "./businessOwner.vue?vue&type=script&lang=js"
export * from "./businessOwner.vue?vue&type=script&lang=js"
import style0 from "./businessOwner.vue?vue&type=style&index=0&id=0d5e0d98&prod&scoped=true&lang=css"
import style1 from "./businessOwner.vue?vue&type=style&index=1&id=0d5e0d98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e0d98",
  null
  
)

export default component.exports